<template>
	<v-container class="pt-4">

		<v-row justify="center">
			<v-col cols="12" sm="8" md="6" lg="4" class="pt-6">
	  		
	  		<!-- Avatar -->
	  		<v-card class="mx-auto px-4 mb-n16  transparent elevation-0" align="center" style="z-index: 1;">
          <v-avatar
            size="180"
            color="transparent"
          >
            <avataaars
            	v-if="getAvatar != null"
	          	:accessoriesType="getAvatar.accessoriesType"
		        	:isCircle="true"
				      :clotheType="getAvatar.clotheType"
		        	:clotheColor="getAvatar.clotheColor"
				      :eyebrowType="getAvatar.eyebrowType"
				      :eyeType="getAvatar.eyeType"
				      :facialHairColor="getAvatar.facialHairColor"
		        	:facialHairType="getAvatar.facialHairType"
				      :graphicType="getAvatar.graphicType"
				      :mouthType="getAvatar.mouthType"
		        	:skinColor="getAvatar.skinColor"
		        	:topType="getAvatar.topType"
		        	:topColor="getAvatar.topColor"
				      :hairColor="getAvatar.hairColor"
				      :circleColor="'#6fb8e0'">
				    </avataaars>

				    <avataaars v-else></avataaars>
          </v-avatar>
				  <v-btn 
	          	absolute
	          	bottom
	          	color="primary" 
	          	small 
	          	@click="avatarParamentro.editar = true" 
	          	fab
	          	class="text-capitalize mb-4"
	          >
          	<v-icon small>mdi-pencil</v-icon>
        	</v-btn>
			  </v-card>

			  <v-card  class="shadowCard  separacionAlta text-center pb-4">
	  			<div>
            <div class="mb-0 font-weight-bold colorCurso text-body-1" >
             	<strong>{{ getUsuarioLMS.nombre_completo }}</strong>
            </div>

            <p class="mb-0 font-weight-bold">
              <strong>{{ getUsuarioLMS.usuario }}</strong>
            </p>
          </div>

	  		  <v-divider class="ma-0 mt-4"></v-divider>

	  		  <v-window
			      v-model="seccionMenu"
			    >
			      <v-window-item>
			        <v-card-actions class="py-4 pb-0">
			  		  	<v-spacer></v-spacer>
			  		  	<v-card class="text-center elevation-0 transparent">
			  		    	<v-btn color="primary" fab small @click="habilitarVentana( 1 )"><v-icon>mdi-account</v-icon></v-btn>
			  		  	  <v-card-text>
			  		  	    Mi cuenta
			  		  	  </v-card-text>
			  		  	</v-card>
			  		  	<v-spacer></v-spacer>
			  		  </v-card-actions>
			      </v-window-item>

			      <v-window-item>
			        <v-card-actions class="py-4 pb-0">
			  		  	<v-spacer></v-spacer>
			  		  </v-card-actions>
			      </v-window-item>
			      
			    </v-window>

			    <v-card-actions class="justify-space-between">
	  		  	<!-- Anterior -->
			      <v-btn
			        text
			        @click="prev"
			      >
			        <v-icon>mdi-chevron-left</v-icon>
			      </v-btn>
			      <v-item-group
			        v-model="seccionMenu"
			        class="text-center"
			        mandatory
			      >
			        <v-item
			          v-for="n in length"
			          :key="`btn-${n}`"
			          v-slot="{ active, toggle }"
			        >
			          <v-btn
			            :input-value="active"
			            icon
			            @click="toggle"
			          >
			            <v-icon small>mdi-record</v-icon>
			          </v-btn>
			        </v-item>
			      </v-item-group>
			      <!-- Siguiente -->
			      <v-btn
			        text
			        @click="next"
			      >
			        <v-icon>mdi-chevron-right</v-icon>
			      </v-btn>
			    </v-card-actions>

	  		</v-card>
	  	</v-col>

	  	<v-col cols="12" sm="8" md="6" lg="4" class="pt-4 px-1">
		  	<MiCuenta       v-if="ventana == 1" :perfil="perfil"/>
		  	<Password       v-if="ventana == 2" />
	    	<Loader         v-if="cargar"       :loader="loader"/>
	    	<AvataraUsuario v-if="avatarParamentro.editar"   :avatarParamentro="avatarParamentro"/>
	  	</v-col>
	  </v-row>
	</v-container>	
</template>
<script>
	import Avataaars from 'vuejs-avataaars'
	import { mapActions, mapGetters } from 'vuex'

	// Dependencias
  const md5     = require('md5')

  // Componentes
  import Alerta          from '@/components/alertas/Alerta.vue'
  import MiCuenta        from '@/components/teachers/MiCuenta.vue'
  import Password        from '@/components/perfil/Password.vue'
  import AvataraUsuario  from '@/components/perfil/AvataraUsuario.vue'
  import Loader          from '@/components/alertas/Loader.vue'

  // Mixins
  import  validarErrores from '@/mixins/validarErrores.js';

  export default {
  	components:{
  		Alerta,
  		MiCuenta,
  		Password,
  		Avataaars,
  		Loader,
  		AvataraUsuario,
  	},

  	mixins:[validarErrores],

    data: () => ({
    	length: 2,
      seccionMenu: 0,

    	editAvatar: false,

      avatar:'',
      ventana: 0,

      perfil: null,

      loader: true,
      cargar: false,

      avatarParamentro: {
      	editar: false
      }
    }),

    computed:{
    	...mapGetters( 'login', [ 'getUsuarioLMS', 'getDatosUsuarioLMS', 'getAvatar']),

    },

    created() {
    	this.cargar = true
    	if(!this.getDatosUsuarioLMS){
    		this.cargar = false
    		this.$router.push({name: 'RegistrarDatos'})
    	}
    	this.perfil = this.getDatosUsuarioLMS

    	this.avatar = "https://ui-avatars.com/api/?background=1976d2&color=fff&rounded=true&format=svg&name=" +
      this.getUsuarioLMS.nombre + this.getUsuarioLMS.apellido_paterno
    	this.cargar = false
    },

    methods: {
    	...mapActions( 'login', [ 'grabarUsuario' ]),

    	habilitarVentana ( ventana ){
    		this.perfil = this.getUsuarioLMS
    		this.ventana = ventana
    	},

      validarDatos () {
        return this.$refs.form.validate()
      },

      next () {
        this.seccionMenu = this.seccionMenu + 1 === this.length
          ? 0
          : this.seccionMenu + 1
      },
      prev () {
        this.seccionMenu = this.seccionMenu - 1 < 0
          ? this.length - 1
          : this.seccionMenu - 1
      },

    },
  }
</script>
<style scoped>
	.separacionAlta{
		padding-top: 100px !important;
		padding-left: 10px !important;
		padding-right: 10px !important;
	}

	.bordesCard{
		border-radius: 14px !important;
	}

	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.15)  !important;
	}

	.cardUsuario{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.1)  !important;
	}

  .colorCurso{
  	color:  #5b5b5b;
  }
</style>
